module.exports = __webpack_public_path__ + "img/icon6.e3d2edd2.png";